// Libs
import Vue from 'vue'
import Router from 'vue-router'
// Main Components
import Home from '@/components/Home'
import CreateProfile from '@/components/CreateProfile'
import TrainingList from '@/components/TrainingList'
// Settings Components
import EatingPlan from '@/components/Settings/EatingPlan'
import Profile from '@/components/Settings/Profile'
import PaymentConfirm from '@/components/Settings/PaymentConfirm'
import ReciptFind from '@/components/Settings/ReciptFind'
import Statisitc from '@/components/Settings/Statisitc'
import Training from '@/components/Settings/Training'
import TrainingFlow from '@/components/Settings/TrainingFlow'
import TrainingEnd from '@/components/Settings/TrainingEnd'
import Login from '@/components/Settings/Login'
// Pages
import PaymentError from '@/components/Pages/PaymentError'
import DeactivationSuccess from '@/components/Pages/DeactivationSuccess'
// LangMHuage Specific
import LP from '@/components/LangKyf/RS/LP'
import Deactivation from '@/components/LangKyf/RS/Deactivation'
import Imprint from '@/components/LangKyf/RS/Imprint'
import Contact from '@/components/LangKyf/RS/Contact'
import Terms from '@/components/LangKyf/RS/Terms'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/create-profile',
            name: 'CreateProfile',
            component: CreateProfile
        },
        {
            path: '/deactivation',
            name: 'Deactivation',
            component: Deactivation
        },
        {
            path: '/deactivation-success',
            name: 'DeactivationSuccess',
            component: DeactivationSuccess
        },
        {
            path: '/imprint',
            name: 'Imprint',
            component: Imprint
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/terms-and-conditions',
            name: 'Terms',
            component: Terms
        },
        {
            path: '/eating-plan',
            name: 'EatingPlan',
            component: EatingPlan
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {
            path: '/recipt-find',
            name: 'ReciptFind',
            component: ReciptFind
        },
        {
            path: '/lp',
            name: 'LP',
            component: LP
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/statisitc',
            name: 'Statisitc',
            component: Statisitc
        },
        {
            path: '/training',
            name: 'Training',
            component: Training
        },
        {
            path: '/training-program',
            name: 'TrainingFlow',
            component: TrainingFlow
        },
        {
            path: '/training-end',
            name: 'TrainingEnd',
            component: TrainingEnd
        },
        {
            path: '/payment-confirmation',
            name: 'PaymentConfirm',
            component: PaymentConfirm
        },
        {
            path: '/payment-error',
            name: 'PaymentError',
            component: PaymentError
        },
        {
            path: '/training-list',
            name: 'TrainingList',
            component: TrainingList
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/kyf/rs.js